const LOGIN = 'LOGIN';
const LOGOUT = 'LOGOUT';

export { LOGIN, LOGOUT }